$(function(){

	let $burger = $('.js-burger'),
		$headerNav = $('.js-header-nav'),
		$header = $('.js-header');

	$burger.on('click', function(){
		$(this).toggleClass('is-active');
		$headerNav.toggleClass('is-active');
		$header.toggleClass('is-dark');
	})

	//mini header
	function fixedHeader(){
		if($W.scrollTop() > 50 ){
			$header.addClass("is-fixed");
		}
		else {
			$header.removeClass("is-fixed");
		}
	}
	fixedHeader();
	$W.scroll(function() {
		fixedHeader();
		
	});

	// let $linkBlock = $('.js-menu-block__link')

	// $linkBlock.on('click', function(e){
	// 	if ( $W.width() <=992 ) {
	// 		e.preventDefault();

	// 		let $unit = $(this).closest('.js-menu-block');
	// 		$unit.find('.js-menu-block__inner').slideToggle();
	// 		$(this).toggleClass('is-active');
	// 	}
	// })

	let $subMenu = $('.js-submenu'),
		$menu = $('.js-menu'),
		$closeMenu = $('.js-close-menu');

	$subMenu.on('click', function(e){
		if( $W.width() <= 992) {
			e.preventDefault();
			$menu.toggleClass('is-active');
			$header.toggleClass('is-dark-desctop');
		}
	});

	$subMenu.on('mouseenter', function(e){
		if( $W.width() > 992) {
			$menu.addClass('is-active');
			$header.addClass('is-dark-desctop');
		}
	});

	$header.on('mouseleave', function(e){
		if( $W.width() > 992) {
			$menu.removeClass('is-active');
			$header.removeClass('is-dark-desctop');
		}
	});

	$closeMenu.on('click', function(e){
		e.preventDefault();
		$menu.removeClass('is-active');
		$header.removeClass('is-dark-desctop')
	});

	// if ($('.js-page-decor').length) {
	// 	$header.addClass('header--no-foil')
	// }

})